const table = {
  columnList: 'Lista de columnas',
  noResults: 'No se encontraron resultados',
  noResultsSubHeader: 'No podemos encontrar ningún elemento que coincida con su búsqueda',
};

export default table;
